module.exports = {
  messages: {
    CN: {
      "yes": '是',
      "no": '否',
      "emailAction": '操作',
      account: {
        groupName: '分组名称',
        EnableMessage: '确定要删除吗？',
        rule: '请输入分组名称',
        sarchValuePl: '搜索商品编号或名称',
        selectGroup: '选择商品',
        emptyDyxTip: '请选择筛选条件后查询得意先',
        noDyx: '暂无数据',
        selected: '已选：得意先',
        goodsName: '商品名称',
        goodsNumber: '商品编号',
        total: '总条数：',
        total2: '合计：',
        message1: '列表存在终卖的商品，请删除后重试',
        delete: '删除',
        edit: '编辑',
        searchContent: '商品信息',
        searchPl: '请输入商品编号或名称',
        goodsCount: '商品数量',
        createUser: '创建者',
        updateTime: '更新时间',
        editGoods: '编辑商品分组',
        goodsCla: '商品分类',
        goodsGroup: '商品分组',
        srx: '仕入先',
        selectDyx: '选择得意先',
        status: '状态',
        dyxContent: '得意先信息',
        dyxContentPl: '搜索得意先编号或名称',
        dyxContentPl2: '请输入得意先编号或名称',
        dyxContentPl3: '请输入得意先名称或电话',
        dyxCount: '得意先数量',
        editDyx: '编辑得意先分组',
        dyxNumber: '得意先编号',
        dyxName: '得意先名称',
        ddz: '担当者',
        yetai: '业态',
        dyxfz: '得意先分组',
        ddfx: '都道府县',
        qqx: '请求先'
      }
    },
    JP: {
      "yes": 'はい',
      "no": 'いいえ',
      "emailAction": '操作',
      account: {
        groupName: 'グループ名',
        EnableMessage: '削除してもよろしいですか？',
        rule: 'グループ名を入力してください',
        sarchValuePl: '商品コードまたは名前を検索',
        selectGroup: '商品を選択',
        emptyDyxTip: '得意先を検索する前にフィルター条件を選択してください',
        noDyx: 'データなし',
        selected: '選択済み：得意先',
        goodsName: '商品名',
        goodsNumber: '商品コード',
        total: '総数：',
        total2: '合計：',
        message1: 'リストには終売の商品が存在します。削除してから再試行してください',
        delete: '削除',
        edit: '編集',
        searchContent: '商品情報',
        searchPl: '商品コードまたは名前を入力してください',
        goodsCount: '商品数量',
        createUser: '作成者',
        updateTime: '更新時間',
        editGoods: '商品グループの編集',
        goodsCla: '商品カテゴリー',
        goodsGroup: '商品グループ',
        srx: '仕入先',
        selectDyx: '得意先を選択',
        status: '状態',
        dyxContent: '得意先情報',
        dyxContentPl: '得意先コードまたは名前を検索',
        dyxContentPl2: '得意先コードまたは名前を入力してください',
        dyxContentPl3: '得意先の名前または電話を入力してください',
        dyxCount: '得意先数',
        editDyx: '得意先グループを編集',
        dyxNumber: '得意先コード',
        dyxName: '得意先名',
        ddz: '担当者',
        yetai: '業態',
        dyxfz: '得意先グループ',
        ddfx: '都道府県',
        qqx: '請求先'
      }
    }
  }
};